import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdbreact";
import Step from "./Step";
import { TextField } from "@material-ui/core";
import { TextFieldChecks } from "../Helpers/TextFieldsChecks";
import Axios from "axios";
export default function Step1(props) {
  const { state, onChangeField, nextStep } = props;
  const [touched, setTouched] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const formRef = new React.createRef();

  useEffect(() => {
    if (state.isCloudStorageEnabled === Boolean) {
      Axios.get("prime.php").then((res) => {
        onChangeField(
          {},
          "isCloudStorageEnabled",
          res.data.isCloudStorageEnabled
        );
        onChangeField({}, "messagePrimeCloud", res.data.content);
      });
    }
  }, []);
  useEffect(() => {
    if (state.lastName && state.firstName) {
      setTouched(true);
    } else {
      setTouched(false);
    }
  }, [state.lastName, state.firstName]);
  // };
  return (
    <Step
      heading={
        "Hey! I'm Madison. I'll help you get your EIN in a couple easy steps. Ready to get started?"
      }
    >
      <MDBContainer>
        <form onSubmit={(e) => e.preventDefault()} ref={formRef}>
          <MDBRow center>
            <MDBCol sm={10} md={8}>
              <MDBRow center>
                <MDBCol md={6}>
                  <TextField
                    style={{
                      font: "600 16px/1.3 Lato, Helvetica Neue, Arial, sans-serif",
                    }}
                    label="First Name"
                    type="text"
                    name="firstName"
                    value={state.firstName}
                    onChange={(e) => {
                      TextFieldChecks("name", e.target.value) &&
                        onChangeField(e, e.target.name, e.target.value);
                    }}
                    autoFocus
                    fullWidth
                    placeholder={`First Name`}
                    variant="outlined"
                  />
                </MDBCol>
                <MDBCol>
                  <TextField
                    label="Last Name"
                    type="text"
                    name="lastName"
                    value={state.lastName}
                    onChange={(e) => {
                      TextFieldChecks("name", e.target.value) &&
                        onChangeField(e, e.target.name, e.target.value);
                    }}
                    fullWidth
                    style={{
                      font: "600 16px/1.3 Lato, Helvetica Neue, Arial, sans-serif",
                    }}
                    placeholder={`Last Name`}
                    variant="outlined"
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow
                center
                className="d-flex flex-column align-items-center last-row"
              >
                {touched && errorMsg.length > 0 && (
                  <div className="text-danger mb-2">{errorMsg}</div>
                )}
                {touched && !errorMsg && (
                  <Link to={nextStep}>
                    <MDBBtn
                      color="pink"
                      rounded
                      type="button"
                      className="z-depth-1a"
                    >
                      Get Started
                    </MDBBtn>
                  </Link>
                )}
                {(!touched || errorMsg) && (
                  <MDBBtn
                    color={"grey"}
                    disabled
                    rounded
                    type="button"
                    className="z-depth-1a mt-4"
                  >
                    Get Started
                  </MDBBtn>
                )}
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </form>
      </MDBContainer>
    </Step>
  );
}
